let cardhobby = {
  addressPage: {
    pageindex: 1,
    pagesize: 999
  },
  sort: [
    'lastontime',
    'price',
    'sales'
  ],
  sortType: [
    'desc',
    'asc'
  ],
  pointOptions: [{
          'value': '全部',
        }, {
          'value': '0-100',
        }, {
          'value': '100-200',
        }, {
          'value': '200-500',
        }],
  dislogType: {
    'market': false,
    'userinfo': false,
    'login': false,
    'register': false,
    'forgot': false,
    'address': false,
    'setOrderAddress': false,
    'payOrder': false,
    'viewexpress': false
  },
  authorize: [
    "../../static/images/footer_mci.svg",
    "../../static/images/footer_fbc.svg",
    "../../static/images/footer_sad.svg",
    "../../static/images/footer_rbf.svg",
    "../../static/images/footer_celtic.svg",
    // "../../static/images/footer_nbpa.svg",
    // "../../static/images/footer_ufc.svg"
  ],
  headerMeu: {
    'home': '首页',
    'market': '达咖市场',
    'point': '积分商城',
    'cypher': '交换卡',
    'information': '达咖资讯',
    'about': '关于我们'
  },
  otherPayOrder: [
  {
    'method': '兴业银行上海市徐汇支行',
    'account': '216210100100197990',
    'company':'上海达咖文化发展有限公司',
    'language': 'ch'
  }, 
  {
    'method': 'The Bank of East Asia, Limited',
    'account': '015-133-68-02019-9',
    'company':'Daka HongKong Culture Development Limited',
    'code': 'BEASHKHH',
    'language': 'en'
  }, 
  ],
  cosConfig: {
    ImagesUrl: "https://images.cardhobby.com/",
    Bucket: "cardhobby-1255531135" /* 必须 */ ,
    Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */ ,
    Key: "exampleobject" /* 必须 */ ,
    Prefix: "", //CardHobby/ /*文件目录*/
    SecretId: "",
    SecretKey: ""
  },
}
export default {
  cardhobby
}



// WEBPACK FOOTER //
// ./src/api/enum.js